import { events, EventsState } from '@shared/state/events';
import { polling, PollingState } from '@shared/state/polling';
import { createStore } from '@stencil/store';
import { schedule, ScheduleState } from './schedule';
import { scripts, ScriptsState } from './scripts';

export type State =
  & { events: EventsState }
  & { polling: PollingState }
  & { schedule: ScheduleState }
  & { scripts: ScriptsState }

export const { state, onChange } = createStore<State>({
  events,
  polling,
  schedule,
  scripts,
});

